import React from 'react';
import { useParams } from 'react-router-dom';

import SharedAppForm from '../components/SharedApp/SharedAppForm';

function SharedAppFormPage() {
  const { 
    id 
  } = useParams();

  return <SharedAppForm id={id} />;
}

export default SharedAppFormPage; 